(() => {
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const cartLink = event.target.closest?.('[data-vg-cart]');
    if (!cartLink || typeof window.mjOpenUpsell !== 'function') return;

    event.preventDefault();
    window.mjOpenUpsell({});
  });

  // Only the visible preview toolbar obstructs the cart; its iframe spans the viewport.
  function watchPreviewBar() {
    const preview = document.getElementById('PBarNextFrameWrapper');
    if (!preview) return false;
    const update = () => {
      const rect = preview.getBoundingClientRect();
      const style = window.getComputedStyle(preview);
      const visible = !preview.hidden && style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0'
        && rect.height > 0 && rect.height < 160 && rect.bottom >= window.innerHeight - 1 && rect.top < window.innerHeight;
      const offset = visible ? Math.min(rect.height, window.innerHeight - rect.top) : 0;
      document.body.style.setProperty('--vg-cart-preview-offset', `${offset}px`);
    };
    new ResizeObserver(update).observe(preview);
    new MutationObserver(update).observe(preview, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    window.addEventListener('resize', update);
    update();
    return true;
  }
  if (!watchPreviewBar()) {
    const previewObserver = new MutationObserver(() => {
      if (watchPreviewBar()) previewObserver.disconnect();
    });
    previewObserver.observe(document.body, { childList: true });
  }
})();
